// extracted by mini-css-extract-plugin
export default {"modal":"SiFUMHCju9zGheI3Vz0s","modal_column":"L62roo9mvIRncTZhFEGt","modal_column-title":"YrpBbIgkIIqMd2KJkFDR"};